export default function Location() {
  return (
    <section id="contacto" className="py-24 px-6 lg:px-20 bg-[#E63946]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-16">
          <p className="text-sm text-white/80 mb-4">VISÍTANOS</p>
          <div className="max-w-2xl">
            <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-8">
              Estamos en<br />
              Pozuelo de<br />
              Alarcón
            </h2>
            <p className="text-2xl text-white/90">
              C. de Antonio Becerril, 10<br />
              28223 Pozuelo de Alarcón, Madrid
            </p>
          </div>
        </div>

        {/* Map */}
        <div className="grid lg:grid-cols-2 gap-6 mb-16">
          <div className="h-[400px] rounded-3xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.8!2d-3.8!3d40.43!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI1JzQ4LjAiTiAzwrA0OCcwMC4wIlc!5e0!3m2!1ses!2ses!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación Kebabish Kebab"
            ></iframe>
          </div>
          <div className="h-[400px] rounded-3xl overflow-hidden shadow-lg">
            <img
              src="https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/6982c82c13689afd46132274414d469b.png"
              alt="Fachada Kebabish Kebab"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Contact Info */}
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-phone-fill text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2">Teléfono</h3>
            <a href="tel:919123048" className="text-xl text-white font-semibold hover:underline cursor-pointer whitespace-nowrap">
              919 123 048
            </a>
            <p className="text-white/90 mt-2">Llámanos para hacer tu pedido</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-time-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2">Horario</h3>
            <p className="text-lg text-white font-semibold">Todos los días</p>
            <p className="text-white/90">12:00-16:00 / 19:00-24:00</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-map-pin-fill text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2">Dirección</h3>
            <p className="text-white">C. de Antonio Becerril, 10</p>
            <p className="text-white/90">28223 Pozuelo de Alarcón</p>
          </div>
        </div>

        {/* Final CTA */}
        <div className="mt-16 text-center bg-white/10 backdrop-blur-sm rounded-[40px] p-16">
          <h3 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            ¿Tienes hambre?
          </h3>
          <p className="text-xl text-white/90 mb-8">
            Te atendemos rápido y con la mejor calidad
          </p>
          <a
            href="tel:919123048"
            className="inline-flex items-center gap-3 bg-gray-900 text-white px-12 py-5 rounded-full text-2xl font-bold hover:bg-gray-800 transition-all hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            Llamar: 919 123 048
          </a>
        </div>
      </div>
    </section>
  );
}
